var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }

import * as React from "react";

function SvgCloseBlkRgb(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 415.75 415.75",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,311.81 H 311.81 V 0 H 0 Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.3333 0 0 -1.3333 0 415.75)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(167.43 154.86)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-0.58 0.578-0.58 1.517 0 2.095l54.391 54.39c0.578 0.581 0.578 1.52 0 2.098l-8.382 8.379c-0.577 0.578-1.514 0.578-2.095 0l-54.391-54.391c-0.577-0.58-1.516-0.58-2.094 0l-54.391 54.391c-0.58 0.578-1.517 0.578-2.098 0l-8.378-8.379c-0.578-0.578-0.578-1.517 0-2.098l54.391-54.39c0.58-0.578 0.58-1.517 0-2.095l-54.391-54.39c-0.578-0.581-0.578-1.521 0-2.098l8.378-8.379c0.581-0.578 1.518-0.578 2.098 0l54.391 54.391c0.578 0.577 1.517 0.577 2.094 0l54.391-54.391c0.581-0.578 1.518-0.578 2.095 0l8.382 8.379c0.578 0.577 0.578 1.517 0 2.098z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseBlkRgb);
export default __webpack_public_path__ + "static/media/Close_BLK_RGB.631c94d209a5017c75529dbf8e880689.svg";
export { ForwardRef as ReactComponent };